import React from 'react';
import Link from '../Link';
import { RESPONSIBLE_DISCLOSURE_POLICY } from '../../constants';

type Props = {
  className?: string;
};

const ResponsibleDisclosure = (props: Props) => (
  <Link className={props.className} to={RESPONSIBLE_DISCLOSURE_POLICY}>
    Responsible Disclosure Policy
  </Link>
);

export default ResponsibleDisclosure;
